<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  
  <div class="page-wrapper">
    <!-- MOBILE VIEW -->
    <div class="content d-lg-none mob-calendar-page">
        <!-- Header -->
        <div class="px-2 mb-4">
           <div class="d-flex align-items-center gap-3">
              <a href="javascript:void(0);" @click="router.push('/dashboard')" class="btn-back-mob shadow-sm">
                 <vue-feather type="arrow-left" size="20"></vue-feather>
              </a>
              <h4 class="fw-bold mb-0">Kalender PO</h4>
           </div>
           <p class="smallest text-muted mt-2 ps-1">Lihat jadwal dan status pesanan berdasarkan tanggal pengiriman.</p>
        </div>

         <!-- Inline Calendar -->
         <div class="card border-0 shadow-xs rounded-4 overflow-hidden mb-4 mx-1 bg-white">
            <div class="card-body p-1">
               <div class="mob-purchase-calendar">
                  <a-calendar 
                     v-model:value="selectedCalendarDate"
                     :fullscreen="false" 
                     @select="handleDateSelect"
                  >
                     <template #headerRender="{ value, type, onChange, onTypeChange }">
                        <div class="custom-calendar-header d-flex align-items-center justify-content-between p-3">
                           <button @click="changeMonth(value, onChange, -1)" class="nav-cal-btn">
                              <vue-feather type="chevron-left" size="18"></vue-feather>
                           </button>
                           <div class="text-center">
                              <h6 class="fw-bold mb-0 text-dark uppercase tracking-wider">
                                 {{ value.format('MMMM YYYY') }}
                              </h6>
                           </div>
                           <button @click="changeMonth(value, onChange, 1)" class="nav-cal-btn">
                              <vue-feather type="chevron-right" size="18"></vue-feather>
                           </button>
                        </div>
                     </template>

                     <template #dateCellRender="{ current }">
                        <div v-if="hasOrders(current)" class="calendar-order-indicator-wrapper">
                           <div class="dot-glow" :class="getAggregatedStatusClass(current)"></div>
                        </div>
                     </template>
                  </a-calendar>
               </div>
            </div>
         </div>

        <!-- Legend / Info -->
        <div class="px-3">
           <h6 class="smallest fw-bold text-muted uppercase mb-3 tracking-wider text-center">Indikator Status Pesanan</h6>
           <div class="legend-grid">
              <div class="legend-item">
                 <div class="legend-dot bg-black"></div>
                 <span>Processing</span>
              </div>
              <div class="legend-item">
                 <div class="legend-dot bg-warning"></div>
                 <span>Partial</span>
              </div>
              <div class="legend-item">
                 <div class="legend-dot bg-success"></div>
                 <span>Completed</span>
              </div>
              <div class="legend-item">
                 <div class="legend-dot bg-secondary"></div>
                 <span>Draft</span>
              </div>
           </div>
        </div>

        <!-- Quick Action Info -->
        <div class="mt-4 px-3 text-center">
           <div class="info-pill-lite p-3 rounded-4">
              <p class="smallest text-muted mb-0">
                <vue-feather type="info" size="12" class="me-1 text-blue"></vue-feather>
                Tap pada tanggal untuk melihat detail pesanan.
              </p>
           </div>
        </div>
    </div>

    <!-- DESKTOP VIEW (Redirect or Message) -->
    <div class="content d-none d-lg-block">
       <div class="text-center py-5">
          <h3>Halaman ini khusus untuk tampilan Mobile</h3>
          <p>Silakan gunakan Dashboard Utama untuk akses Desktop.</p>
          <router-link to="/dashboard/admin-dashboard" class="btn btn-primary">Kembali ke Dashboard</router-link>
       </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useDataStore } from '@/store/dataStore';
import dayjs from 'dayjs';

const router = useRouter();
const { orders } = useDataStore();
const selectedCalendarDate = ref(dayjs());

const handleDateSelect = (date, info) => {
    // Only redirect if selecting the day, not when changing panel
    if (info.source === 'date') {
        const formattedDate = date.format('YYYY-MM-DD');
        router.push({
            path: '/purchases/order-list',
            query: { date: formattedDate }
        });
    }
};

const changeMonth = (current, onChange, delta) => {
   const newValue = current.add(delta, 'month');
   onChange(newValue);
};

const hasOrders = (current) => {
    const dateStr = current.format('YYYY-MM-DD');
    return orders.value.some(o => (o.tanggal_order || "").split('T')[0] === dateStr);
};

const getAggregatedStatusClass = (current) => {
    const dateStr = current.format('YYYY-MM-DD');
    const dayOrders = orders.value.filter(o => (o.tanggal_order || "").split('T')[0] === dateStr);
    
    if (dayOrders.length === 0) return '';
    
    const hasProcessing = dayOrders.some(o => {
        const shipped = o.shipped_qty || 0;
        const total = o.total_qty || 0;
        return o.status === 'draft' || (shipped === 0 && total > 0);
    });
    
    if (hasProcessing) return 'bg-black';
    
    const hasPartial = dayOrders.some(o => {
        const shipped = o.shipped_qty || 0;
        const total = o.total_qty || 0;
        return shipped > 0 && shipped < total;
    });
    
    if (hasPartial) return 'bg-warning';
    
    return 'bg-success';
};
</script>

<style scoped>
.mob-calendar-page {
    padding-top: 20px;
    background: #fdfdfd;
}

.btn-back-mob {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e293b;
  border: 1px solid #f1f5f9;
  transition: all 0.2s;
}
.btn-back-mob:active {
  transform: scale(0.9);
  background: #f8fafc;
}

.mob-purchase-calendar :deep(.ant-picker-calendar-header) {
    display: none;
}

.custom-calendar-header {
    background: #ffffff;
    border-bottom: 1px solid #f1f5f9;
}

.nav-cal-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #f8fafc;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #475569;
    transition: all 0.2s;
}

.nav-cal-btn:active {
    transform: scale(0.9);
    background: #f1f5f9;
}

.mob-purchase-calendar :deep(.ant-picker-cell) {
    padding: 2px 0 !important;
}

.mob-purchase-calendar :deep(.ant-picker-cell-inner) {
    width: 40px !important;
    height: 40px !important;
    margin: 0 auto !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    border-radius: 12px !important;
    position: relative !important;
    border: 1px solid transparent;
}



/* Neutralize Today Marker */
.mob-purchase-calendar :deep(.ant-picker-cell-today .ant-picker-cell-inner::before) {
    border: none !important;
}
.mob-purchase-calendar :deep(.ant-picker-cell-today .ant-picker-cell-inner) {
    color: inherit !important;
    font-weight: normal !important;
}

.mob-purchase-calendar :deep(.ant-picker-cell-selected .ant-picker-cell-inner) {
    background: #029147 !important;
    color: white !important;
    box-shadow: 0 4px 12px rgba(2, 145, 71, 0.3);
    border-radius: 12px !important;
}

.calendar-order-indicator-wrapper {
    position: absolute;
    bottom: 5px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    pointer-events: none;
}

.dot-glow {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    border: 1px solid rgba(255,255,255,0.2);
}

.legend-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.legend-item {
    background: white;
    padding: 10px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #f1f5f9;
    box-shadow: 0 2px 5px rgba(0,0,0,0.02);
}

.legend-item span {
    font-size: 10px;
    font-weight: 700;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.bg-black { background: #1e293b !important; }
.bg-warning { background: #f59e0b !important; }
.bg-success { background: #10b981 !important; }
.bg-secondary { background: #94a3b8 !important; }

.uppercase { text-transform: uppercase; letter-spacing: 0.5px; }
.smallest { font-size: 11px; }

.shadow-xs { box-shadow: 0 2px 8px rgba(0,0,0,0.02); }
.info-pill-lite { background: #f8fafc; border: 1px solid #f1f5f9; }
.text-blue { color: #3b82f6; }
</style>
